import styled from 'styled-components';
import { transition } from 'components/shared/skeleton-ui/skeleton-ui.component';
import { Thumbnail as TokenThumbnail } from 'components/shared/signed-thumbnail';

export const THUMBNAIL_DEAFULT_SIZE = '100px';

const ThumbnailWrapper = styled.div`
  animation: ${transition} 1.5s infinite;
  width: ${THUMBNAIL_DEAFULT_SIZE};
  height: ${THUMBNAIL_DEAFULT_SIZE};
  cursor: pointer;
`;

const Button = styled.button`
  border: 0;
  background-color: transparent;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`;

const Anchor = styled.a`
  border: 0;
  background-color: transparent;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
`;

const Image = styled(TokenThumbnail)`
  width: ${THUMBNAIL_DEAFULT_SIZE};
  height: ${THUMBNAIL_DEAFULT_SIZE};
  object-fit: cover;
`;

interface ThumbnailProps {
  filePath: string,
  fileName: string,
  width: string,
  damageId?: string | undefined,
}

interface ButtonThumbnailProps extends ThumbnailProps {
  id: string,
  onClick: (id: string) => void
}

const ButtonThumbnail = (props: ButtonThumbnailProps) => {
  const { id, onClick } = props;

  return (
    <ThumbnailWrapper>
      <Button onClick={() => onClick(id)}>
        <Thumbnail {...props} />
      </Button>
    </ThumbnailWrapper>
  );
};

interface AnchorThumbnailProps extends ThumbnailProps {
  href: string,
  target: string
}

const AnchorThumbnail = (props: AnchorThumbnailProps) => {
  const { href, target } = props;

  return (
    <ThumbnailWrapper>
      <Anchor href={href} target={target}>
        <Thumbnail {...props} />
      </Anchor>
    </ThumbnailWrapper>
  );
};

const Thumbnail = (props: ThumbnailProps) => {
  const { filePath, width, damageId, fileName } = props;
  if (filePath.length === 0) return null;

  return (
    <Image
      f={filePath}
      w={width}
      d={damageId}
      alt={fileName}
      title={fileName}
      draggable={false}
    />
  );
};

export { ButtonThumbnail, AnchorThumbnail };
